module.exports = __webpack_public_path__ + "img/chat.840e19f3.svg";